/**
 * Short, human labels for a file's type and size, used by list views such as
 * Recently Filed. Raw MIME types like
 * "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
 * are too long for a table cell, so the label comes from the filename
 * extension first and falls back to the MIME subtype.
 */

const SIZE_UNITS = ["Bytes", "KB", "MB", "GB", "TB"];

export function fileTypeLabel(file) {
    const name = (file && file.filename) || "";
    const dot = name.lastIndexOf(".");
    if (dot > 0 && dot < name.length - 1) {
        return name.slice(dot + 1).toUpperCase();
    }

    const mime = (file && file.mime_type) || "";
    const slash = mime.indexOf("/");
    if (slash === -1) {
        return mime || "File";
    }
    return mime.slice(slash + 1).toUpperCase();
}

export function fileSizeLabel(bytes) {
    const size = Number(bytes);
    if (!size || size <= 0) {
        return "0 Bytes";
    }
    const k = 1000;
    const i = Math.min(Math.floor(Math.log(size) / Math.log(k)), SIZE_UNITS.length - 1);
    return `${parseFloat((size / Math.pow(k, i)).toFixed(2))} ${SIZE_UNITS[i]}`;
}
